import { Injectable } from '@angular/core';

@Injectable()
export class CachingService {
    private readonly mailLabel = "mail";
    private readonly phoneLabel = "phone";
    private readonly messageLabel = "message";
    private readonly secretLabel = "secret";
    private readonly googleAuthTokenLabel = "gToken";
    private readonly googleAuthTokenIssuedTimeLabel = "gTokenIssuedTime";
    private readonly expirationDelayMs = 3600000;
    private readonly defaultMessageValue =
        "Je suis intéressé(e) par cette annonce, merci de me contacter.";

    public constructor() {
    }

    public getMail(): string {
        return localStorage.getItem(this.mailLabel);
    }

    public setMail(mail: string) {
        localStorage.setItem(this.mailLabel, mail);
    }

    public getPhone(): string {
        return localStorage.getItem(this.phoneLabel);
    }

    public setPhone(phone: string) {
        localStorage.setItem(this.phoneLabel, phone);
    }

    public getMessage(): string {
        const message = localStorage.getItem(this.messageLabel);
        return message === null ? this.defaultMessageValue : message;
    }

    public setMessage(message: string) {
        localStorage.setItem(this.messageLabel, message);
    }

    // TODO: refactor this upon switching to OAuth token *only*
    public getSecret(): string {
        return localStorage.getItem('secret');
    }

    public setSecret(secret: string) {
        localStorage.setItem(this.secretLabel, secret);
    }

    // HACK: pretty sure implementing a TTL over localStorage is not appropriate
    public getGoogleAuthToken(): string {
        const issuedTime = Number(localStorage.getItem(this.googleAuthTokenIssuedTimeLabel));
        const currentTime = Number(Date.now().toString());
        const tokenStillValid = (currentTime - issuedTime) < this.expirationDelayMs;
        if (issuedTime != null && tokenStillValid) {
            return localStorage.getItem(this.googleAuthTokenLabel);
        }
        return null;
    }

    public setGToken(gToken: string) {
        localStorage.setItem(this.googleAuthTokenLabel, gToken);
        localStorage.setItem(this.googleAuthTokenIssuedTimeLabel, Date.now().toString());
    }
}
